// ============================================================================
// MAGPRESS CUSTOM: Product page gallery slider (FINAL + MOBILE ARROWS)
// - desktop: nooled + pildi klikk = ringiratast
// - mobiil: swipe = ringiratast + meie enda nooled = ringiratast
// ============================================================================

(function () {
  if (window.__magpressGalleryInited) return;
  window.__magpressGalleryInited = true;

  function initMagpressGallerySlider() {
    const mediaWrapper = document.querySelector('.product__media-wrapper');
    if (!mediaWrapper) return;

    // Pisipildid – kasutame neid "peidetud juhtpuldina"
    const thumbsList = document.querySelector('ul[id^="Slider-Thumbnails-"]');
    if (!thumbsList) return;

    const thumbButtons = Array.from(
      thumbsList.querySelectorAll('button.thumbnail')
    );
    if (thumbButtons.length <= 1) return; // ainult 1 pilt – pole midagi libistada

    // Noolenupud ja counter (desktopi nooled)
    const prevBtn = mediaWrapper.querySelector('button.slider-button--prev');
    const nextBtn = mediaWrapper.querySelector('button.slider-button--next');
    const counter = mediaWrapper.querySelector('.slider-counter');

    if (!prevBtn || !nextBtn) return;

    // Kõik pildi “interaction” alad kõigis slaidides
    let interactionAreas = Array.from(
      mediaWrapper.querySelectorAll('.product__modal-opener--image')
    );
    if (interactionAreas.length === 0) {
      interactionAreas = [mediaWrapper];
    }

    // Aktiivne index aria-current järgi
    function getActiveIndex() {
      return thumbButtons.findIndex(
        (btn) => btn.getAttribute('aria-current') === 'true'
      );
    }

    let currentIndex = getActiveIndex();
    if (currentIndex < 0) currentIndex = 0;

    function updateCounter() {
      if (!counter) return;
      counter.textContent = `${currentIndex + 1}/${thumbButtons.length}`;
    }

    updateCounter();

    // ÜHINE funktsioon – nooled + klikk + swipe
    function goTo(index) {
      const total = thumbButtons.length;

      // ringiratast liikumine
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;

      currentIndex = index;

      // Klõpsa vastaval thumbnailil – teema vahetab suure pildi ise
      thumbButtons[currentIndex].click();

      // väike viivitus, et Sense jõuaks aria-current paika panna
      setTimeout(() => {
        const realIndex = getActiveIndex();
        if (realIndex >= 0) currentIndex = realIndex;
        updateCounter();
      }, 30);
    }

    // --- DESKTOP NOOLED (kasutavad goTo, käivad ringiratast) ---
    prevBtn.addEventListener('click', (event) => {
      event.preventDefault();
      goTo(currentIndex - 1);
    });

    nextBtn.addEventListener('click', (event) => {
      event.preventDefault();
      goTo(currentIndex + 1);
    });

    // --- SWIPE + KLIKK KÕIGIL PILTIDEL ---
    interactionAreas.forEach((area) => {
      // Swipe mobiilis (ringiratast)
      const SWIPE_THRESHOLD = 40;
      let startX = 0;
      let deltaX = 0;
      let active = false;

      function onTouchStart(e) {
        if (!window.matchMedia('(max-width: 989px)').matches) return;
        if (e.touches.length > 1) return;

        active = true;
        startX = e.touches[0].clientX;
        deltaX = 0;
      }

      function onTouchMove(e) {
        if (!active) return;
        deltaX = e.touches[0].clientX - startX;
      }

      function onTouchEnd() {
        if (!active) return;

        if (Math.abs(deltaX) > SWIPE_THRESHOLD) {
          if (deltaX < 0) {
            // sõrm vasakule → järgmine pilt
            goTo(currentIndex + 1);
          } else {
            // sõrm paremale → eelmine pilt
            goTo(currentIndex - 1);
          }
        }

        active = false;
        startX = 0;
        deltaX = 0;
      }

      if ('ontouchstart' in window) {
        area.addEventListener('touchstart', onTouchStart, { passive: true });
        area.addEventListener('touchmove', onTouchMove, { passive: true });
        area.addEventListener('touchend', onTouchEnd);
      }

      // Desktop: klikk pildil = järgmine pilt (ringiratast)
      area.addEventListener('click', (e) => {
        if (!window.matchMedia('(min-width: 990px)').matches) return;
        e.preventDefault();
        goTo(currentIndex + 1);
      });
    });

    // --- MAGPRESS OMA MOBIILINOOLED (peidame teema omad CSS-iga) ---
    const mobileArrows = document.createElement('div');
    mobileArrows.className = 'magpress-mobile-arrows';
    mobileArrows.innerHTML = `
      <button type="button" class="magpress-arrow magpress-arrow--prev" aria-label="Eelmine pilt">‹</button>
      <button type="button" class="magpress-arrow magpress-arrow--next" aria-label="Järgmine pilt">›</button>
    `;
    mediaWrapper.appendChild(mobileArrows);

    const mobilePrev = mobileArrows.querySelector('.magpress-arrow--prev');
    const mobileNext = mobileArrows.querySelector('.magpress-arrow--next');

    mobilePrev.addEventListener('click', function () {
      goTo(currentIndex - 1);
    });

    mobileNext.addEventListener('click', function () {
      goTo(currentIndex + 1);
    });
  }

  document.addEventListener('DOMContentLoaded', initMagpressGallerySlider);
  document.addEventListener('shopify:section:load', initMagpressGallerySlider);
})();